import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardLiveQueryOptions } from '../api/liveQuery';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import {
  DEFAULT_QUEUE_PAGE,
  EMPTY_QUEUE_FILTERS,
  NeedsApprovalData,
  QueueFilterValues,
  QueuePage,
} from '../api/types';

// Shifts with a pending decision + fraction sub-state.
const useNeedsApprovalQueue = (
  agencyId: number,
  filters: QueueFilterValues = EMPTY_QUEUE_FILTERS,
  page: QueuePage = DEFAULT_QUEUE_PAGE,
) =>
  useQuery<NeedsApprovalData>({
    queryKey: dashboardV2QueryKeys.needsApproval(agencyId, filters, page),
    queryFn: () => dashboardV2Client.getNeedsApproval(agencyId, filters, page),
    enabled: agencyId != null,
    ...dashboardLiveQueryOptions,
  });

export default useNeedsApprovalQueue;
